import { fromFetch } from 'rxjs/fetch';
import { AuthHeaders } from '../../models/auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { authwsEnvironment } from './authws-environment';
import { productOwnershipSchema } from './schemas/product-ownership.schema';

export function getProductsAccounts(product: string, accountId: number) {
  return fromFetch(
    new Request(authwsEnvironment.productsAccountsUrl(product, accountId), {
      method: 'GET',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
    })
  ).pipe(selectData(productOwnershipSchema));
}
